import { Content } from '../../types';

export const sihanoukvilleContent: Content = {
  title: 'סיהנוקוויל',
  imageUrl: 'https://tinyurl.com/sihanoukville-wide',
  introduction: `סיהאנוקוויל הינה עיר חוף השוכנת בדרום-מערב קמבודיה, לאורך חופו המזרחי של מפרץ תאילנד. העיר נחשבת לאחת מנקודות התיירות המרכזיות במדינה, בזכות חופיה היפים, האיים הסמוכים והאווירה הייחודית שהיא מציעה למבקרים.`,
  sections: [
    {
      title: 'חופים ואטרקציות מרכזיות',
      content: [
        {
          subtitle: 'החופים המרכזיים:',
          text: `סיהאנוקוויל מוקפת בשרשרת חופים מרהיבים, כאשר העיקריים שבהם כוללים:
• Independence Beach – חוף שקט ונקי, מתאים לאלו המחפשים רוגע ושלווה.
• Sokha Beach – חוף יוקרתי השייך בחלקו לריזורט יוקרתי, עם חול לבן ומים צלולים.
• Serendipity Beach – החוף המרכזי של העיר, בו ניתן למצוא שפע של מסעדות, ברים, מלונות וחיי לילה תוססים.
• Otres Beach – חוף פופולרי במיוחד בקרב תרמילאים, עם אווירה רגועה, מסעדות חוף וצימרים במחירים נוחים.`,
        },
        {
          subtitle: 'אטרקציות נוספות:',
          text: `בנוסף לחופים, בעיר ניתן למצוא מספר אטרקציות נוספות:
• שוק הלילה של סיהאנוקוויל – מקום נהדר לחוות את התרבות המקומית, לטעום מאכלים קמבודיים מסורתיים ולרכוש מזכרות.
• Wat Leu – מקדש בודהיסטי השוכן על גבעה, ממנו נשקף נוף פנורמי מרהיב של העיר והחופים.
• Ream National Park – שמורת טבע הממוקמת לא הרחק מהעיר, ובה יערות מנגרובים, נהרות וחיות בר ייחודיות.`,
        },
      ],
      type: 'list',
    },
    {
      title: 'האיים הסמוכים',
      content: `שני האיים המרכזיים בקרבת העיר הם:
• Koh Rong – אי עם חופים בתוליים, מים צלולים ושפע פעילויות, כולל צלילה, שנורקלינג וקייקים.
• Koh Rong Sanloem – אי קטן ושקט יותר, אידיאלי למי שמחפש חופשה רומנטית או הרחק מההמולה.

אל האיים ניתן להגיע בסירות ומעבורות היוצאות מנמל Serendipity Pier ומנמל הסחורות הגדול של העיר Port Autonome de Sihanoukville (PAS).`,
      type: 'text',
    },
    {
      title: 'תמורות כלכליות ופיתוח מואץ',
      content: `החל משנת 2017, עם חתימת הסכם כלכלי בין קמבודיה לסין, החלה תנופת בנייה חסרת תקדים בעיר. אוכלוסייה סינית רבה היגרה למקום, מרבית העסקים עברו לבעלות סינית ונפתחו בתי קזינו רבים. כיום, העיר משמשת כמרכז הימורים גדול ופונה בעיקר לתיירות סינית, אך עדיין ניתן למצוא בה מקומות השומרים על האופי המקומי.`,
      type: 'text',
    },
    {
      title: 'דרכי הגעה',
      content: `סיהאנוקוויל מקושרת היטב לשאר חלקי קמבודיה:
• באוטובוס – ניתן להגיע מהבירה פנום פן או מסיאם ריפ באמצעות אוטובוסים ושאטלים.
• בטיסה – שדה התעופה של סיהאנוקוויל ממוקם כ-20 דקות נסיעה מהעיר ומציע בעיקר טיסות פנימיות אך גם מספר טיסות בינלאומיות.
• ברכב פרטי או מונית – אופציה נוחה יותר למי שמחפש גמישות בנסיעה.`,
      type: 'text',
    },
    {
      title: 'בשורה התחתונה',
      content: `סיהאנוקוויל הינה עיר עם פנים משתנות, המשלבת בין חופים יפהפיים, חיי לילה סוערים, פיתוח כלכלי מהיר והשפעות תרבותיות מגוונות. למחפשים חופשת חוף בקמבודיה, עם אפשרות לטיולים באיים סמוכים, זהו יעד שכדאי להביא בחשבון.`,
      type: 'text',
    },
  ],
};
